export default function TennisIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <g transform="rotate(-38 30 30)">
        <rect x="27" y="38" width="7" height="22" rx="3" fill="#2F8BFF" />
        <rect x="28.5" y="34" width="4" height="7" fill="#3B434F" />
        <ellipse cx="30.5" cy="20" rx="14" ry="17" fill="none" stroke="#E7ECF3" strokeWidth="4.5" />
        <path d="M22 9v22M27 5v30M32 4v32M37 5v30M18 14h25M17 20h27M18 26h25M21 31h19" stroke="#E7ECF3" strokeOpacity="0.45" strokeWidth="1.4" />
      </g>
      <circle cx="49" cy="47" r="9" fill="#D7F03A" />
      <path d="M41.5 43.5c4 1.2 6.5 5 6 9.5M56.5 50.5c-4-1.2-6.5-5-6-9.5" stroke="#FFFFFF" strokeWidth="1.8" fill="none" strokeLinecap="round" />
    </svg>
  );
}
